import sign from 'jwt-encode';
import { PatientProps } from '../../../contexts/PatientContext';

export function getSignedToken(patient: PatientProps | undefined, authorization: string) {
  const objToken = {
    patient,
    authorization
  };

  const jwtToken = sign(objToken, '');
  window.location.href = `${process.env.REACT_APP_APPOINTMENT_MODULE_URL}?token=${jwtToken}`;
}
